//
//
//
//
//
//
//
//
//
//

  import { fixKeyboardPage, isWeChat } from '@/utils/utils'
  import DragBall from './components/common/DragBall.vue'
  import {isAlipayMiniProgram, isZLB} from './utils/utils'
  export default {
    name: 'App',
    components: {
      DragBall
    },
    data () {
      return {
        btnText: '进入老年模式',
        itemHeight: 40,
        isWec: false
      }
    },
    created () {
      if (isWeChat()) {
        this.isWec = true
      }
      // 是否是微信端
      if (!isWeChat()) return
      // 修复iOS12，微信端web页面键盘回收后，页面超出部分不回弹bug
      fixKeyboardPage()
      // 首次进入
      this.setNormal()
      if (isZLB || isAlipayMiniProgram) {
        // eslint-disable-next-line no-undef
        ZWJSBridge.getUiStyle().then((result) => {
          // console.log(result);
          if (result.uiStyle === 'normal') {
            this.setNormal()
          } else {
            this.setElder()
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    methods: {
      // 适老化改造
      goOld () {
        let oldtype = sessionStorage.getItem('oldtype')
        if (oldtype === 'normal' || !oldtype) {
          this.itemHeight = 80
          this.setElder()
        } else {
          this.itemHeight = 40
          this.setNormal()
        }
      },
      setElder () {
        document.documentElement.style.fontSize = '50px'
        sessionStorage.setItem('oldtype', 'elder')
        if (document.querySelector('.cus-container .nine-section-box')) {
          document.querySelector('.cus-container .nine-section-box').className += ' older_nine-section-box'
        }
        this.$store.commit('SET_elder', 'elder')
        this.btnText = '退出老年模式'
      },
      setNormal () {
        document.documentElement.style.fontSize = '37.5px'
        sessionStorage.setItem('oldtype', 'normal')
        if (document.querySelector('.cus-container .nine-section-box')) {
          document.querySelector('.cus-container .nine-section-box').className = 'nine-section-box'
        }
        this.$store.commit('SET_elder', 'normal')
        this.btnText = '进入老年模式'
      }
    }
  }



// WEBPACK FOOTER //
// ./src/App.vue